export enum SortType {
  string = 'string',
  date = 'date',
  dateTime = 'dateTime',
  number = 'number',
  time = 'time',
  icon = 'icon',
  standardEntity = 'standardEntity',
}
